import SendModuleStart from '@/modules/sendsms/views/SendSmsStart.vue';
import SendModulePreview from "@/modules/sendsms/views/SendSmsPreview";

export const SendSmsRoutes = [
    {
        path: '/sendsms',
        component: SendModuleStart,
    },
    {
        path: '/sendsms/preview',
        component: SendModulePreview,
    }
];
